<template>  
<div> <!-- root element start -->

  <div class="row">
    <div class="col-12">

      <div class="card border-0">
        <div class="card-header h5 bg-transparent border-0">Change Name</div>
        <div class="card-body">

              <hr class="bg-dark">

              <div class="row"><!--  email row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Username/Email</span>
                </div>

                <div class="col-md-5">
                  <div class="row">
                    <div class="form-group col-12">
                      <label class="d-none d-md-block" for="exampleInputEmail1">Username / Email</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Email" v-model="email">
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                </div>
                <div class="col-md-3  h-100 justify-content-center align-self-center">
                  <button v-if="emailButton == false" class="btn btn-warning" @click="resetEmail">Reset</button>
                  <button v-if="emailButton == false" class="btn btn-success" @click="sendEmailChange">Save Email</button>
                </div>
              </div>

              <hr class="bg-dark">
              <div class="row"><!--  name row -->

                <div class="col-md-2 h-100 justify-content-center align-self-center">
                  <span class="h6 font-weight-bold ">Name</span>
                </div>

                <div class="col-md-7">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label class="d-none d-md-block" for="exampleInputEmail1">First Name</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="First Name" v-model="f_name">
                    </div>
                    <div class="form-group col-md-6">
                      <label for="exampleInputEmail1">Last Name</label>
                      <input type="text" class="form-control" aria-describedby="emailHelp" placeholder="Last Name" v-model="l_name">
                    </div>
                  </div>
                </div>

                <div class="col-md-3  h-100 justify-content-center align-self-center">
                  <button v-if="nameButton == false" class="btn btn-warning" @click="resetName">Reset</button>
                  <button v-if="nameButton == false" @click="sendNameChange" class="btn btn-success">Save Name</button>
                </div>
              </div>

              

              <hr class="bg-dark">

              
        </div>
      </div>



    </div> <!--  initial column end -->
  </div> <!--  initial row end -->

</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/settings-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 
      email: '',
      f_name: '',
      l_name: '',

    }
  },
  computed: {
    userData() { return this.$store.state.userData },
    userDataComp() { return this.$store.state.userDataComp },

    nameButton: function(){
      var _this = this;
      if((_this.f_name != _this.userData.f_name || _this.l_name != _this.userData.l_name) && _this.f_name != '' &&  _this.f_name != null && _this.l_name != ''&&  _this.l_name != null) {
        return false;
      } else {
        return true;
      }
    },
    emailButton: function(){
      var _this = this;
      if(_this.email != _this.userData.email && _this.email != '' &&  _this.email != null) {
        return false;
      } else {
        return true;
      }
    },

  },
  watch: {
    userData() { this.onOpen(); }
  },
  mounted() {
    this.onOpen();
  },
  methods: {
    onOpen() {
      var _this = this;
      _this.email = _this.userData.email;
      _this.f_name = _this.userData.f_name;
      _this.l_name = _this.userData.l_name;
    },

    resetEmail() {
      var _this = this;
      _this.email = _this.userData.email;
    },
    resetName() {
      var _this = this;
      _this.f_name = _this.userData.f_name;
      _this.l_name = _this.userData.l_name;
    },

    sendNameChange() {
      var _this = this;
      _this.$toastr.warning('Validating name information.', 'Please wait!')
      var valErrors = [];
      if(_this.f_name == '' || _this.f_name == null || _this.f_name.length < 2) {  valErrors.push("A valid first name is required!") }
      if(_this.l_name == '' || _this.l_name == null || _this.l_name.length < 2) {  valErrors.push("A valid first name is required!") }
      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 
      _this.$toastr.remove()
      axios.post('/utility/user/user/updatename', {
        user_id: _this.userData.id,
        f_name: _this.f_name,
        l_name: _this.l_name,
      })
      .then(function (response) {
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['account-edit' ])
      })
      .catch(function (error) {
        _this.$toastr.remove()
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      })
    },

    sendEmailChange() {
      var _this = this;
      _this.$toastr.warning('Validating email information.', 'Please wait!')
      var valErrors = [];
      var mailformat = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
      if(_this.email == '' || _this.email == null) {  valErrors.push("An email is required!") } else { if(!_this.email.match(mailformat)) { valErrors.push("The customer facing email you entered is invalid!") } }
      if(valErrors.length > 0) {
        _this.$toastr.remove();
        _this.errorDisplay(valErrors);
        return false;
      } 
      _this.$toastr.remove()
      axios.post('/utility/user/user/updateemail', {
        user_id: _this.userData.id,
        email: _this.email,
      })
      .then(function (response) {
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['account-edit' ])
      })
      .catch(function (error) {
        _this.$toastr.remove()
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      })
    },

    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },

  },    
  components:{
    
  },
  filters: {

  }
}
</script>
